<template>
    <div :id="map.id" @click="onClick"><img :id="map.id" :src="map.asset.src" />{{ map.id }}</div>
</template>

<style scoped>
img {
    width: 50px;
    height: 50px;
}
</style>

<script lang="ts">
export default {
    props: {
        map: {
            type: Object,
            default: function() {
                return {
                    id: 'default',
                    asset: { kind: 'image', src: '/static/assets/marc.png' },
                };
            },
        },
    },
    methods: {
        onClick: function() {
            this.$emit('onMapClick', { map: this.$props.map });
        },
    },
};
</script>
